import { render, staticRenderFns } from "./buyGetOne.vue?vue&type=template&id=23fb2bb7&"
import script from "./buyGetOne.vue?vue&type=script&lang=ts&"
export * from "./buyGetOne.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports